/**
 * Sidebar navigation module
 *
 * @module app/components/SidebarNavigation
 */
import _ from 'lodash';
import affix from './Affix';
import jQuery from 'jquery';
import MessageBusTopics from '../../common/MessageBusTopics';
import PageCommon from '../pages/PageCommon';
import URLProvider from './URLProvider';

/**
 * Global PubSub reference
 *
 * @type {Object}
 *
 * @private
 */
var pubSub = window.WH.messageBus;

/**
 * Current sport to be matched against whenever there's a sport update
 *
 * @type {string}
 *
 * @private
 */
var activeSport = null;

/**
 * Maps PubSub topics to their handlers
 *
 * @type {Object}
 *
 * @private
 */
var topicMapper = {

    /**
     * Updates the UI to reflect a sport change during the in-page navigation
     *
     * @param {Object} args Args published
     *
     * @returns {void}
     *
     * @private
     */
    sport: function updateSport(args) {

        if (activeSport && (activeSport !== args.sport)) {

            processSportChange(args);
        }

        activeSport = args.sport;
    },

    /**
     * Updates the UI to reflect a page change during the in-page navigation
     *
     * @param {Object} args Args published
     *
     * @returns {void}
     *
     * @private
     */
    'page': function updatePage(args) {

        var $nav = jQuery('#sidebar-left');

        $nav.find('li.contextual-nav__item--active').removeClass('contextual-nav__item--active');
        $nav.find(args.navSelector).addClass('contextual-nav__item--active');
    },
};

/**
 * Processing a change of sports. If the new sport and the current one are using the same 'all sports' sidebar,
 * we just update the selected menu entry, otherwise we fully refresh the sidebar
 *
 * @param {Object} args Args published
 *
 * @returns {void}
 *
 * @private
 */
var processSportChange = function processSportChange(args) {

    if (_.includes(URLProvider.allSports, activeSport) &&
        _.includes(URLProvider.allSports, args.sport)) {

        topicMapper.page(args);
    } else {

        api.refreshSidebarLeft({
            sport: args.sport,
            page: args.page,
            locale: getLang(),
        });
    }
};

/**
 * Binds in-page navigation for not non route sidebar links
 *
 * @returns {void}
 *
 * @private
 */
var bindSidebarLeftNavigation = function () {

    jQuery('.main')
        .off('click.SidebarNavigation')
        .on('click.SidebarNavigation', '.contextual-nav a:not(.non-route)', PageCommon.navigate);
};

/**
 * Get lang
 *
 * @returns {String}
 *
 * @private
 */
var getLang = function () {

    return (window.WH.sportsbook.hasOwnProperty('lang')) ? window.WH.sportsbook.lang : 'en-gb';
};

/**
 * Setup affix commons
 *
 * @returns {void}
 *
 * @private
 */
var sidebarAffixInitCommon = function () {

    affix.init({
        sidebarMVPTop: function () {

            return 0;
        },
        sidebarMVPFixedTop: function () {

            return jQuery('.localnavigation').outerHeight(true) + 40;
        },
        sidebarOptionsTop: function () {

            var offset = jQuery('.maincenter').offset();

            return offset ? offset.top : 0;
        },
        sidebarOptionsTopSidebarLeft: function () {

            var offset = jQuery('.maincenter').offset();

            return offset ? offset.top + 8 : 0;
        },
        sidebarOptionsBottom: function () {

            var offset = jQuery('.footer__main').offset();

            return parseInt(jQuery(document).height() - (offset ? offset.top : 0) +
                jQuery('.prefooter__back-to-top-wrapper').outerHeight(true), 10);
        },
    });

    affix.setup(jQuery('nav[id!="sidebar-left"] > .sidebar__group'), getSidebarOptions('sidebarOptionsTop'));
    affix.setup(jQuery('#sidebar-left > .sidebar__group'), getSidebarOptions('sidebarOptionsTopSidebarLeft'));
};

/**
 * Setup affix non iOS
 *
 * @returns {void}
 *
 * @private
 */
var sidebarAffixInitNonIOS = function () {

    if (jQuery('.header.header--ios').length === 0) {

        affix.addSizeFunction('localNavigationTop', function () {

            return jQuery('header.header').outerHeight(true);
        })
            .addSizeFunction('localNavigationDropdownTop', function () {

                return jQuery('section.localnavigation').height();
            });

        affix.setup(jQuery('section.localnavigation'), { topOff: 'localNavigationTop' });
        affix.setup(jQuery('nav.localnavigation-dropdown, .localnavigation-dropdown--xsell'),
            {
                topOff: 'localNavigationDropdownTop',
            });
    }
};

/**
 * Applies the bootstrap-affix plugin.
 * Used to keep the sidebars in place on scroll.
 *
 * @returns {void}
 *
 * @private
 */
var sidebarAffixInit = function () {

    sidebarAffixInitCommon();
    sidebarAffixInitNonIOS();

    affix.refresh();
};

/**
 * Constructs and returns sidebars options for the affix plugin
 *
 * @returns {Object} options object for affix
 *
 * @private
 */
var getSidebarOptions = function (topOffFunc) {

    var options;
    var navMenusDefaultOffset = 24;

    if (jQuery('.header.header--ios').length === 0) {
        options = {
            topOff: topOffFunc,
            bottomOff: 'sidebarOptionsBottom',
            defaultTopOff: navMenusDefaultOffset,
        };
    }
    else {
        options = {
            topOff: 'sidebarMVPTop',
            fixedTopOff: 'sidebarMVPFixedTop',
            defaultTopOff: navMenusDefaultOffset,
        };
    }

    return options;
};

/**
 * Fixes left sidebar '#sidebar-left > .sidebar__group' position
 *
 * @returns {void}
 *
 * @private
 */
var sidebarLeftAffix = function () {

    affix.setup(jQuery('#sidebar-left > .sidebar__group'), getSidebarOptions('sidebarOptionsTopSidebarLeft'));
    affix.refresh();
};

/**
 * Subscribes to navigation argument changes
 *
 * @returns {void}
 *
 * @private
 */
var subscribeToArgsChanges = function () {

    pubSub.subscribe(MessageBusTopics.NAVIGATION_ARGS, argsChangeListener);
};

/**
 * Listens to argument changes on the subscribed topic
 *
 * @param {string} topic Topic under the update was published
 * @param {Object} args Published updates
 *
 * @returns {void}
 *
 * @private
 */
var argsChangeListener = function (topic, args) {

    var changedProp = topic.split('.').pop();

    var handler = topicMapper[changedProp];

    if (_.isFunction(handler)) {

        handler(args);
    }
};

/**
 * Public functions.
 *
 * @type {Object}
 */
var api = {

    /**
     * init method to inject deps, set the lastSport and to bind the links
     *
     * @returns {void}
     *
     * @public
     */
    init: function () {

        bindSidebarLeftNavigation();
        subscribeToArgsChanges();
        sidebarAffixInit();
    },

    /**
     * Reloads full left sidebar into $('nav.sidebar.-contextual')
     * All three args keys are required (locale, sport, page)
     *
     * @param {Object} args - locale, sport, page
     * @param {function} afterSuccess - optional parameter for callback after reload success, if it's undefined
     *        it will assign the default success callback to fix sidebar position and bind navigation
     *
     * @returns {void}
     *
     * @public
     */
    refreshSidebarLeft: function (args, afterSuccess) {

        /**
         * preRender callback, we need to pull out the html from rendered sidebar snippet,
         * otherwise it will insert $('nav.sidebar.-contextual') inside $('nav.sidebar.-contextual')
         *
         * @param {Object} data
         *
         * @returns {void}
         *
         * @private
         */
        var preRender = function (data) {

            return jQuery(data).closest('#sidebar-left-context').html();
        };

        /**
         * afterSuccess callback, to fix left sidebar positioning and bind navigate
         *
         * @param {Object} data
         *
         * @returns {void}
         *
         * @private
         */
        if (_.isUndefined(afterSuccess)) {

            afterSuccess = function () {

                // Bind sidebar navigation
                bindSidebarLeftNavigation();

                //Fix sidebar positioning
                sidebarLeftAffix();
            };
        }

        // Reloads left sidebarLeft snippet
        PageCommon.reloadSnippet({
            'requestURL': URLProvider.sidebarLeft.full(args),
        }, '#sidebar-left-context', {
            'preRender': preRender,
            'afterSuccess': afterSuccess,
        }, true);
    },

    /**
     * Exposes module function to fix left sidebar position
     *
     * @returns {void}
     *
     * @public
     */
    sidebarLeftAffix: sidebarLeftAffix,
};

export default api;
